module.exports = __webpack_public_path__ + "static/media/VRF.96c3890c.png";